import parse from 'html-react-parser';

import { ScrollArea } from 'components/ui/scroll-area';
import { cn } from 'lib/utils';

interface HTMLPreviewProps {
  className?: string;
  htmlString?: string;
}

export default function HTMLPreview({
  className,
  htmlString,
}: HTMLPreviewProps) {
  if (!htmlString) return null;

  return (
    <ScrollArea
      className={cn(
        'h-[calc(100vh-14rem)] xl:h-[calc(100vh-13.5rem)]',
        className
      )}
    >
      {parse(htmlString)}
    </ScrollArea>
  );
}
